
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { useTranslation } from 'react-i18next';
import DashboardButton from "./dashboardButton";


export default function IndexSetting() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Setting',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4 directions  h-[100vh] mb-5 ">

                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Setting" DashboardMenu={DashboardMenu}></DashboardButton>

              
                
            </div>

        </>
    )
}